export default function takeScreenshotPlugin() {
  return {
    name: 'take-screen-command',

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async executeCommand({ command, payload, session }) {
      if (command === 'take-screenshot') {
        if (session.browser.type === 'playwright') {
          return true;

          // eslint-disable-next-line no-unreachable
          const page = session.browser.getPage(session.id);
          await page.screenshot({
            path: `./__screenshots__/test-run/${payload}.png`,
            fullPage: true,
          });

          return true;
        }

        // you might not be able to support all browser launchers
        throw new Error(
          `Taking screenshots is not supported for browser type ${session.browser.type}.`,
        );
      }
      return undefined;
    },
  };
}
